import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { DOCFORMAT_INIT_LOADING, DOCFORMAT_INIT_SUCCESS, DOCFORMAT_INIT_FAIL, DOCFORMAT_DEFTEXT_LOADING, DOCFORMAT_DEFTEXT_SUCCESS, DOCFORMAT_DEFTEXT_FAIL,
  CLAUSE_INIT_SUCCESS, CLAUSE_INIT_FAIL, CLAUSE_INIT_LOADING } from '../../../types'

const state = {
  init: 0,
  initErr: [],
  menu: {},
  defTextListing: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const getters = {

}

const mutations = {
  [DOCFORMAT_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [DOCFORMAT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [DOCFORMAT_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [DOCFORMAT_DEFTEXT_LOADING](state) {
    state.defTextListing.init = 0
    state.defTextListing.initErr = []
    state.defTextListing.menu = {}
  },
  [DOCFORMAT_DEFTEXT_SUCCESS](state, data) {
    state.defTextListing.init = 1
    state.defTextListing.initErr = []
    state.defTextListing.menu = data.menu
  },
  [DOCFORMAT_DEFTEXT_FAIL](state, error) {
    state.defTextListing.init = 2
    state.defTextListing.initErr = error
    state.defTextListing.menu = {}
  },
  [CLAUSE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [CLAUSE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [CLAUSE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async docFormatManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.docFormatManagement
    if (apiUrl) {
      commit(DOCFORMAT_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        // let apiURL = commitResult.menu.getDefTextList
        // if (apiURL) {
        //   const result = await http.get(apiURL)
        //   commit(DOCFORMAT_DEFTEXT_SUCCESS, result.data.defTextListing)
        // }
        commit(DOCFORMAT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(DOCFORMAT_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(DOCFORMAT_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  }
  // async defTextInit({ commit, state }) {
  //   const apiUrl = state.menu.
  //   console.log(apiUrl)
  //   if (apiUrl) {
  //     commit(DOCFORMAT_DEFTEXT_LOADING)
  //     try {
  //       const result = await http.get(apiUrl)
  //       console.log(result)
  //       const menu = extractMenu(result.data._links)
  //       const commitResult = result.data
  //       Object.assign(commitResult, {
  //         menu: menu
  //       })
  //       commit(DOCFORMAT_DEFTEXT_SUCCESS, commitResult)
  //     } catch (error) {
  //       commit(DOCFORMAT_DEFTEXT_FAIL, extractMessages(error))
  //     }
  //   } else {
  //     commit(DOCFORMAT_DEFTEXT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
  //   }
  // }
}

export default {
  state,
  getters,
  mutations,
  actions
}
